import { type FunctionComponent } from "react";
import { Chip } from "@bracket/react-chip";

import "./Bars.scss";

export declare type BarsBannerProps = {};

export const BarsBanner: FunctionComponent<BarsBannerProps> = ({}) => {
  const classes = () => [`points-banner`].join(" ");

  return (
    <div className={classes()}>
      <div className="title">
        <h3>Bars</h3>
        <Chip color="success" interactive={false}>
          Season 1
        </Chip>
      </div>
      <div className="description" style={{ marginBottom: "16px" }}>
        <p>
          Get [BARS], invite friends, stack boosts.{" "}
          <span className="subtle">
            Expect 24hrs before for each [BARS] update.
          </span>
        </p>
      </div>
    </div>
  );
};
